<template>
  <ModalContainer
    v-model="modal"
    title="Your mission has been selected!"
    button="View mission plan"
    image="plan/mission.png"
    :disableClose="true"
    @button-click="goToNext()"
  >
    <p>Your mission objective is:</p>
    <div class="flex flex-row justify-center mb-4">
      <div class="flex flex-col p-4 rounded-lg border-2 border-teal-200 bg-teal-100/20 text-center w-fit">
        <div class="">Bed time</div>
        <div class="text-4xl font-bold">{{ formatTime(this.missionObjective) }}</div>
      </div>
    </div>
  </ModalContainer>
</template>

<script>
import ModalContainer from '@/components/ModalContainer'
import { time24To12 } from '@/helpers/time'
import { mapStores } from 'pinia'
import { usePlanStore } from '@/stores/plan'

export default {
  name: 'PlanStart',
  components: {
    ModalContainer,
  },
  props: {
  },
  emits: [
  ],
  data() {
    return {
      modal: true,
      missionObjective: undefined,
    }
  },
  beforeMount() {
    this.loadPlan()
  },
  watch: {
  },
  methods: {
    async loadPlan() {
      await this.planStore.load()
      this.missionObjective = this.planStore.missionObjective.bedTime
    },
    formatTime(value) {
      return !value ? '' : time24To12(value)
    },
    goToNext() {
      this.$router.push('/plan/outline')
    },
  },
  computed: {
    ...mapStores(usePlanStore),
  }
}
</script>